<script>

	import {API, http_headers} from '../global.js'
	import {onMount} from 'svelte'
	import {createEventDispatcher} from 'svelte'
	const dispatch = createEventDispatcher()
	const close = () =>	dispatch('close')

	let _complejos = ['','RDA','RDE']
	let _idcomplejo = 1
	let _productos = ['','SEM','PUN']
	let _idproducto = 1
	let _monedas=['','$','U$s']	
	let _capacidades = ['3PAX','4PAX','6PAX','8PAX','2PAX(*)','4PAX(*)','2PAX(*)']
	let _temporadas=['PUN','PLA','ORO','ROY','CLA','---','PRE','REL']

	let anio = (new Date).getFullYear()
	let update = false

	$: make_table = async() => {
		let query = `select 
								idtemporada,idcapacidad,puntos,idmoneda,importe
								from precios_cam pc 
								where cuota=${anio} and idproducto =${_idproducto}
								and idhotel=${_idcomplejo}`
		let rs = await fetch(`${API}/exec-query?u=${update}`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		if(ds.success) return ds.data
		else throw new Error(ds)


	}

</script>

<div class="offcanvas offcanvas-end show" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style="visibility: visible;">
  <div class="offcanvas-header">
		<div class="row">
			<div class="col">
				<select bind:value={_idproducto}>
					{#each _productos as pr, index}
						<option value="{index}">{pr}</option>
					{/each}
				</select>
				<select bind:value={_idcomplejo}>
					{#each _complejos as co, index}
						<option value="{index}">{co}</option>
					{/each}
				</select>
				<input class="text-center" type='text' bind:value={anio} size=4 tabindex="-1" />
			</div>
		</div>
	  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" on:click="{close}"></button>
  </div>
  
  <div class="offcanvas-body">

  	{#await make_table()}
			<p>Loading....</p>
		{:then rs}
			<table class="table table-sm table-striped table-hover">
				<tbody>
					{#each rs as item, index}
						<tr class="t{item.idtemporada}">
							<td>{_temporadas[item.idtemporada]}</td>
							{#if _idproducto==1}
								<td>{_capacidades[item.idcapacidad]}</td>
							{:else}
								<td class="text-end">{item.puntos}</td>
							{/if}
							<td>&nbsp;</td>
							<td class="text-end">{_monedas[item.idmoneda]}</td>
							<td class="text-end">{item.importe.toFixed(2)}</td>
						</tr>

					{/each}
				</tbody>
			</table>
		{/await}

  </div>
</div>


<style>
	.t1 { background-color:#e3e4e5; }
	.t2 { background-color:#efb810; }
	.t3 { background-color:#70ff8b; }
	.t4 { background-color:pink; }
	.t6 { background-color:#e3f4e5; }
	.t7 { background-color:#ef8810; }
	.x{}
</style>